import type {EAddress} from "./EAddress";

export interface DuplicityQuery {
    exclude: number;
    country?: string;
    ico?: string;
    company?: string;
    eaddresses?: EAddress[];
    birthNumber?: string;
    symbol?: string;
}

export const REFACTOR_LOCAL = 1;	// refactor using JS local call
export const REFACTOR_REMOTE = 2;	// refactor using AJAX remote call
export const REFACTOR_REDIR = 3;	// refactor using standard redirect to URL

export type RefactorType = number;

export type RefactorAction = "clearField" | "merge" | "removeEA";


export interface PartyRefactoringParams {
    [key: string] : any
}

export interface PartyRefactoring {
    action: RefactorAction;
    title: string;
    type: RefactorType;
    params: PartyRefactoringParams;
}

export interface PartyDuplicate {
    id: number;
    fileAs: string;
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    entered: string;
    enteredBy?: string;
    owners?: string;
    reason?: string;
    refactorings?: PartyRefactoring[]
}

export interface DuplicityReponse {
    count: number;
    queryTime: number;
    duplicates: PartyDuplicate[]
}
